<h1 mat-dialog-title>Please enter the following details.</h1>
<div mat-dialog-content>
  <mat-form-field color="primary">
    <input class="dialog-form-field" matInput [(ngModel)]="data.jira" maxlength="12"
           placeholder="Jira">
  </mat-form-field>
  <mat-form-field color="primary">
    <input class="dialog-form-field" matInput [(ngModel)]="data.comment" maxlength="64"
           placeholder="Comment">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="cancel()" cdkFocusInitial>Cancel</button>
  <button mat-raised-button color="warn" [disabled]="!data.jira || !data.comment" [mat-dialog-close]="data">Approve
  </button>
</div>
